// extracted by mini-css-extract-plugin
export default {"countdown":"Aaa-z","srOnly":"Baa-z"};